import { Prop, Component, h, Watch } from "@stencil/core";
import { ScalePriceData } from "@apis/model/scalePrices";
/**
 * @name    f-scale-prices-table
 *
 * @description
 * representation of lists
 */
@Component({
  tag: "f-scale-prices-table",
  styleUrl: "table.scss",
})
export class Table {
  @Prop() tableData: ScalePriceData[] | string;
  @Prop() symbol = "≥";
  @Prop() quantityLabel = "QUANTITY";
  @Prop() priceLabel = "PRICE EACH";
  private _tableData: ScalePriceData[];

  @Watch("tableData")
  arrayDataWatcher(newValue: ScalePriceData[] | string) {
    if (typeof newValue === "string") {
      newValue = newValue.replace(/ 0+(?![\. }])/g, " ");
      this._tableData = JSON.parse(newValue);
    } else {
      this._tableData = newValue;
    }
  }

  componentWillLoad() {
    this.arrayDataWatcher(this.tableData);
  }
  render() {
    return (
      <table class="m-table">
        <thead>
          <th>{this.quantityLabel}</th>
          <th>{this.priceLabel}</th>
        </thead>
        <tbody>
          {this._tableData?.map((data) => (
            <tr>
              <td>
                {this.symbol}
                {data.minQuantity}
              </td>
              <td>{data.formattedValue}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}
